import { OrderStatusEnum } from '../enums/orderStatus';
import { OrderModel } from '../models/order';
import { convertDateStringToNormalDateTime } from './convertDateFormat';
import { convertOrderStatusEnumToStatusCode } from './convertOrderStatusValue';

export const findOrderCreateTime = (order: OrderModel): string => {
  try {
    const findDate: string = order?.orderStatusTime?.dateTime?.filter(
      (item) =>
        item?.statusOrder?.code ===
        convertOrderStatusEnumToStatusCode(OrderStatusEnum.CURRENT_ORDER)
    )[0]?.time;
    const result=convertDateStringToNormalDateTime(findDate);
    
    return result==="Invalid date" ? convertDateStringToNormalDateTime(order?.createdAt) : result;
  } catch (err) {
    return convertDateStringToNormalDateTime(order?.createdAt);
  }
};
